var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "contactPersonModal",
          attrs: {
            id: "contactPersonModal",
            "ok-variant": "primary",
            "cancel-variant": "link",
            "ok-title": _vm.$t("message.contactPersonDialog.btn.submit"),
            "cancel-title": _vm.$t("message.contactPersonDialog.btn.cancel")
          },
          on: { ok: _vm.onSubmit }
        },
        [
          _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
            _c("span", { staticClass: "ti-user" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.contactPersonDialog.title")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit($event)
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "contactPersonSalutation",
                    "label-for": "contactPersonSalutation"
                  }
                },
                [
                  _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.contactPersonDialog.label.salutation")
                        ) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("b-form-radio-group", {
                    attrs: {
                      options: _vm.salutations,
                      state: _vm.$v.contactPerson.salutation.$error
                        ? false
                        : null
                    },
                    on: {
                      change: function($event) {
                        _vm.$v.contactPerson.salutation.$touch()
                      }
                    },
                    model: {
                      value: _vm.contactPerson.salutation,
                      callback: function($$v) {
                        _vm.$set(_vm.contactPerson, "salutation", $$v)
                      },
                      expression: "contactPerson.salutation"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "contactPersonFirstName",
                            "label-for": "contactPersonFirstName"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.contactPersonDialog.label.firstName"
                                    )
                                  ) +
                                  "\n              "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              state: _vm.$v.contactPerson.firstName.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contactPerson.firstName.$touch()
                              }
                            },
                            model: {
                              value: _vm.contactPerson.firstName,
                              callback: function($$v) {
                                _vm.$set(_vm.contactPerson, "firstName", $$v)
                              },
                              expression: "contactPerson.firstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "contactPersonLastName",
                            "label-for": "contactPersonLastName"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.contactPersonDialog.label.lastName"
                                    )
                                  ) +
                                  "\n              "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              state: _vm.$v.contactPerson.lastName.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.contactPerson.lastName.$touch()
                              }
                            },
                            model: {
                              value: _vm.contactPerson.lastName,
                              callback: function($$v) {
                                _vm.$set(_vm.contactPerson, "lastName", $$v)
                              },
                              expression: "contactPerson.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "contactPersonEmail",
                    "label-for": "contactPersonEmail"
                  }
                },
                [
                  _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.contactPersonDialog.label.email")
                        ) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      state: _vm.$v.contactPerson.email.$error ? false : null
                    },
                    on: {
                      change: function($event) {
                        _vm.$v.contactPerson.email.$touch()
                      }
                    },
                    model: {
                      value: _vm.contactPerson.email,
                      callback: function($$v) {
                        _vm.$set(_vm.contactPerson, "email", $$v)
                      },
                      expression: "contactPerson.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2480b7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2480b7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactPerson/ContactPersonDialog.vue
// module id = fM/p
// module chunks = 1